module.exports = __webpack_public_path__ + "static/media/aucdom.1636a29f.csv";